export default function (request, { urltemplate, server }) {
  const prefix = `${server.API_SERVER}/access`
  const prefix2 = `${server.API_SERVER}/cu`

  return {
    login (data) {
      return request({
        url: `${prefix}/accounts/actions/login`,
        method: 'post',
        data: data
      })
    },

    logout () {
      return request({
        url: `${prefix}/accounts/actions/logout`,
        method: 'post'
      })
    },

    changePassword ({ params, body }) {
      return request({
        url: urltemplate(`${prefix}/accounts/:userId/password`, params),
        method: 'put',
        data: body
      })
    },

    getUserInfo () {
      return request({
        url: `${prefix2}/customer_user`,
        method: 'get'
      })
    },

    getImageCaptcha () {
      return request({
        url: `${prefix}/inner/code/captcha.jpg?t=${Date.now()}`,
        method: 'get',
        responseType: 'blob'
      })
    },

    verifyAccount ({ body }) {
      return request({
        url: `${prefix}/accounts/actions/verifyAccount`,
        method: 'post',
        data: body
      })
    },

    sendMessage ({ body }) {
      return request({
        url: `${prefix}/accounts/actions/sendMessage`,
        method: 'post',
        data: body
      })
    },

    verifyMessage ({ body }) {
      return request({
        url: `${prefix}/accounts/actions/verifyMessage`,
        method: 'post',
        data: body
      })
    },

    resetPassword ({ body }) {
      return request({
        url: `${prefix}/accounts/actions/resetPassword`,
        method: 'post',
        data: body
      })
    },

    // 获取套餐信息
    getComboInfo () {
      return request({
        url: `${prefix2}/customer/order`,
        method: 'get'
      })
    }

  }
}
